<p
  *ngIf='component.data$ | async as data'
  [innerHTML]='data.content | cxSupplementHashAnchors | safeResourceHtml'
></p>
